import 'css-chunksrc/client/pages/projectPage/resourcesPage/filters/sortDropDown/styles.scss';export default {
  "sortDropDown": "_sortDropDown_hgnnx_1",
  "listRoot": "_listRoot_hgnnx_5"
};